// extracted by mini-css-extract-plugin
export default {"loadingDots":"LoadingDots_loadingDots__PsOE0","dot":"LoadingDots_dot__4F6Nt","loadingAnimation":"LoadingDots_loadingAnimation__GOCV8"};